import { useMutation } from '@tanstack/react-query';
import { deleteCryptoAddress } from '../requests';

type Options = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

type DeleteCryptoAddressVariables = {
  templateId: string;
  networkName: string;
};

export function useDeleteCryptoAddress({ onSuccess, onError }: Options) {
  const mutation = useMutation<void, Error, DeleteCryptoAddressVariables>({
    mutationFn: ({ templateId, networkName }) =>
      deleteCryptoAddress(templateId, networkName),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
